import React, { Suspense } from "react";
import { Spinner } from "@heroui/react";
import { useCardDBInfiniteScroll } from "@/components/DeckBuilder/hooks/useCardDBInfiniteScroll";

export default function CardDB({
  filters,
  displayCards,
  hasNextPage,
  fetchNextPage,
  page,
}: {
  filters: any;
  displayCards: any;
  hasNextPage: () => boolean;
  fetchNextPage: () => void;
  page: number;
}) {
  const { scrollRef, sentinelRef } = useCardDBInfiniteScroll({
    hasNextPage,
    fetchNextPage,
    resetOnChange: filters,
    page,
  });

  return (
    <Suspense
      fallback={
        <div className="w-full h-full flex items-center justify-center">
          <Spinner />
        </div>
      }
    >
      <div
        ref={scrollRef}
        className="overflow-scroll"
        style={{
          height: "calc(100svh - 88px - 44px - 8px - 8px)",
        }}
      >
        <div
          id="card-db"
          className="grid grid-cols-[repeat(auto-fill,minmax(114px,1fr))] gap-0 pt-3 px-2 pb-2"
        >
          {displayCards}
        </div>
        {hasNextPage() && (
          <div
            ref={sentinelRef}
            className="flex justify-center py-4 min-h-[48px]"
          >
            <Spinner size="sm" />
          </div>
        )}
      </div>
    </Suspense>
  );
}
